export const GET_LEAD_LISTS = 'get_lead_lists';
export const GET_PROJECT_LISTS = 'get_project_lists';
export const GET_USER_LISTS = 'get_user_lists';
export const CREATE_LEAD_PLAN_OFFER = 'create_lead_plan_offer';
export const UPDATE_LEAD_PLAN_OFFER = 'update_lead_plan_offer';
export const DELETE_LEAD_PLAN_OFFER = 'delete_lead_plan_offer';
export const CREATE_LEAD_PLAN = 'create_lead_plan';
export const UPDATE_LEAD_PLAN = 'update_lead_plan';
export const DELETE_LEAD_PLAN = 'delete_lead_plan';
export const CREATE_LEAD_OFFER = 'create_lead_offer';
export const UPDATE_LEAD_OFFER = 'update_lead_offer';
export const DELETE_LEAD_OFFER = 'delete_lead_offer';
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const ERROR = "error";